import { FC, useState } from 'react';

import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

import { TypeSubEngineInstallment } from '@/lib/api/subscriptionManager/types';

import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';

import { Box } from '../Box';

import { TypeERCBox } from '../../utils';
import PromoCreditsBanner from '@/components/account/_components/PromoCreditsBanner/PromoCreditsBanner';

export type NextOrderProps = {
  t: TypeAccountERCTranslations;
  nextOrder: TypeERCBox;
};

const NextOrder: FC<NextOrderProps> = ({ t, nextOrder }) => {
  const [installmentData, setInstallmentData] = useState(
    nextOrder.installmentData as TypeSubEngineInstallment,
  );

  return (
    <>
      <div className="grid gap-y-2 md:gap-y-4">
        <Heading
          tag={HeadingTag.H1}
          size={HeadingSize.H1}
          classes="px-6 xl:px-0"
          text={t.nextOrder}
        />

        {nextOrder.orderData && nextOrder.installmentData && (
          <PromoCreditsBanner
            userUuid={nextOrder.orderData?.user_uuid}
            subscriptionUuid={nextOrder.installmentData?.subscription_id}
            message={t.promoCreditBannerMessage}
            classes="mx-6 xl:mx-0 lg:items-center"
          />
        )}

        {nextOrder.orderData && (
          <Box
            t={t}
            orderData={nextOrder.orderData}
            installmentData={installmentData}
            setInstallmentData={setInstallmentData}
            productData={nextOrder.productData}
            paymentMethodData={nextOrder.paymentMethodData}
            isNextOrder
          />
        )}
      </div>
    </>
  );
};

export default NextOrder;
